export default __webpack_public_path__ + "static/funrings-e00c6788e7575f5f83be5eecacfc1c6e.png";